import { render, staticRenderFns } from "./UserProfileQualificationEditDialog.vue?vue&type=template&id=1c79e1dc&scoped=true"
import script from "./UserProfileQualificationEditDialog.vue?vue&type=script&lang=js"
export * from "./UserProfileQualificationEditDialog.vue?vue&type=script&lang=js"
import style0 from "./UserProfileQualificationEditDialog.vue?vue&type=style&index=0&id=1c79e1dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c79e1dc",
  null
  
)

export default component.exports